import exchangeRatesApi, { ExchangeRatesRequest, ExchangeRatesResponse } from '@api/exchangeRates'
import { makeLoader } from '@lib/loader'

export const useExchangeRatesLoader = makeLoader<ExchangeRatesRequest, ExchangeRatesResponse>({
  key: 'exchange-rates',
  enabled: ({ currencies }) => currencies != null,
  loader: async params => await exchangeRatesApi.load(params),
})
